import React from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { Table } from "react-bootstrap";
import withRouter from "../../../util/WithRouter";
import Constants from "../../../util/Constants";
import ApiUiController from "../../../controller/ApiUiController";
import DailySalesReportAPI from './../../../api/DailySalesReportAPI';
import ChartComponent from "../FixedReportChart";

class DailySalesLeadSource extends React.Component {
  constructor(props) {
    super(props);

    // Load source options from local storage
    const sourceOptions = reactLocalStorage.getObject(Constants.Model).source.options;

    this.state = {
      sourceData: [], // Data received from the API
      sourceOptions,  // Predefined source options
    };
  }

  componentDidMount() {
    // Fetch data from the API
    DailySalesReportAPI.getDailyLeadSource(
      this.props.filters,
      this.handleReceivedData,
      this.handleFail
    );
  }

  handleReceivedData = (data) => {
    // Filter out items where source is 0
    const filteredData = data.filter(item => item.source !== 0);
    this.setState({ sourceData: filteredData });
  };

  handleFail = () => {
    console.error("Failed to fetch data");
  };

  render() {
    const { sourceData, sourceOptions } = this.state;

    // Create a record of sums for each source option, starting at 0
    const sourceSums = {};
    sourceOptions.forEach(option => {
      sourceSums[option.value] = 0;
    });

    // Fill in the actual values from the API data
    sourceData.forEach(item => {
      if (sourceSums.hasOwnProperty(item.source)) {
        sourceSums[item.source] = item.sum;
      }
    });

    // Calculate the total sum of all source values
    const totalSum = Object.values(sourceSums).filter(Boolean).reduce((total, value) => total + value, 0);
    return (
      <ApiUiController inApiCall={false}>
        <div>
          <h2>Lead Source Report</h2>
          <hr />
          <div className="row mt-3">
            <Table striped bordered hover className="col-md-6">
              <thead>
                <tr>
                  <th>Source</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                {sourceOptions.map((option, index) => (
                  <tr key={index}>
                    <td>{option.label}</td>
                    <td>{sourceSums[option.value]}</td>
                  </tr>
                ))}
                <tr>
                  <td><strong>Total</strong></td>
                  <td><strong>{totalSum}</strong></td>
                </tr>
              </tbody>
            </Table>

            {/* Chart in col-md-5 */}
            <div className="col-md-6">
              {/* Pass only progressSums and progressOptions to ChartComponent */}
              <ChartComponent progressSums={sourceSums} progressOptions={sourceOptions} type={"pie"} />
            </div>
          </div>
        </div>
      </ApiUiController>
    );
  }
}

export default withRouter(DailySalesLeadSource);
